import Vue from "vue";
import App from "./App.vue";
import store from "./store";
import vuetify from "./plugins/vuetify";
import VueConfetti from "vue-confetti";
import NProgress from "nprogress";
import "nprogress/nprogress.css";
import axios from "axios";

Vue.use(VueConfetti);

Vue.config.productionTip = false;

Vue.component('v-style', {
	render: function (createElement) {
		return createElement('style', this.$slots.default)
	}
});

// create a new axios instance
const instance = axios.create({
	// baseURL: "http://localhost:8080"
});

// before a request is made start the nprogress
instance.interceptors.request.use(config => {
  NProgress.start();
  return config;
});

// before a response is returned stop nprogress
instance.interceptors.response.use(response => {
  NProgress.done();
  return response;
});

Vue.prototype.$axios = instance;

new Vue({
  store,
  vuetify,
  render: h => h(App)
}).$mount("#app");